import { AbstractControl, ValidatorFn } from '@angular/forms';

export function singleByteValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value?.toString();

		if (!value) {
			return null;
		}

		return Array.from(value).every((_, idx) => value.charCodeAt(idx) < 255)
			? null
			: {
					notSingleByte: true,
			  };
	};
}
